
// Capture console errors and warnings for debugging
function captureConsole() {
  if (!window._errors) {
    window._errors = [];
  }

  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    window._errors.push({
      type: 'error',
      message: args.join(' '),
      timestamp: Date.now()
    });
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    window._errors.push({
      type: 'warn', 
      message: args.join(' '),
      timestamp: Date.now()
    });
    originalWarn.apply(console, args);
  };
}

// Auto-initialize
captureConsole();
